import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function StarIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 2.66666C8.21771 2.66666 8.41052 2.8075 8.47656 3.01496L9.53255 6.33332H12.8333C13.0469 6.33332 13.2367 6.46917 13.306 6.67121C13.3752 6.87313 13.309 7.0967 13.1406 7.22785L10.403 9.35611L11.3158 12.7018C11.373 12.9119 11.2877 13.135 11.1048 13.2532C10.922 13.3714 10.6837 13.3577 10.5156 13.2194L7.99999 11.1471L5.48437 13.2194C5.31628 13.3577 5.07799 13.3714 4.89518 13.2532C4.71232 13.135 4.62697 12.9119 4.68424 12.7018L5.59635 9.35611L2.85937 7.22785C2.69098 7.0967 2.62475 6.87313 2.694 6.67121C2.76333 6.46917 2.95306 6.33332 3.16666 6.33332H6.46744L7.52343 3.01496L7.55403 2.94075C7.63809 2.77467 7.8094 2.66666 7.99999 2.66666ZM7.30989 6.98502C7.24385 7.19248 7.05105 7.33332 6.83333 7.33332H4.62434L6.47395 8.77213C6.61314 8.88053 6.68348 9.05289 6.66341 9.2246L6.64908 9.29817L6.06249 11.4473L7.68229 10.1139L7.7552 10.0644C7.93235 9.96476 8.1562 9.98101 8.3177 10.1139L9.93684 11.4473L9.35091 9.29817C9.29785 9.10356 9.36691 8.89606 9.52604 8.77213L11.3756 7.33332H9.16666C8.94894 7.33332 8.75613 7.19248 8.6901 6.98502L7.99999 4.81575L7.30989 6.98502Z"
        fill="currentColor"
      />
    </svg>
  );
};
